import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useModal } from '@mssgme/ui';

import UpdateDialog from './UpdateDialog';

async function prepareWorker() {
    if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
    }

    if ('serviceWorker' in navigator) {
        const reg = await navigator.serviceWorker.getRegistration();
        if (!reg) return;
        await reg.update();
    }
}

export default function CheckUpdate() {
    const modal = useModal();
    const isExpired = useSelector((state) => state.ui.isClientExpired);

    useEffect(() => {
        if (isExpired) {
            prepareWorker().then(() => {
                modal.show();
            });
        }
    }, [isExpired]);

    return <UpdateDialog {...modal.props} />;
}
